import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default deliveryOptionId => createSelector(
  [getSettings],
  settings => !!(settings.hide_store_info
    && settings.hide_store_info.includes(deliveryOptionId)),
);
